module.exports = __webpack_public_path__ + "static/img/jclb2.a7ddec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jclb2.png
// module id = WaWY
// module chunks = 1